import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './lang/en.json'
import zh from './lang/zh.json'
import LanguageDetector from 'i18next-browser-languagedetector'

const resources = {
    "en": {
        translation: en
    },
    "zh": {
        translation: zh
    }
}

const currentLocale = localStorage.getItem('lan') || 'zh';

i18n
    // 将 i18n 实例传递给 react-i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    // 初始化 i18next
    // 所有配置选项: https://www.i18next.com/overview/configuration-options
    //@ts-ignore
    .init({
        resources,
        fallbackLng: currentLocale, // 默认当前的语言环境
        lng: currentLocale,
        debug: true,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });

export default i18n;
